import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import {
  buildSentryTracePropagationTargets,
  hydratePortalSentryUserFromStorage,
  initPortalSentry,
  setPortalSentryTag,
} from '@admin-panel/observability';
import { BrowserRouter } from 'react-router';

import App from './app/Application';
import { ensureDeviceFingerprint, getDeviceFingerprint } from '@admin-panel/utils';

import './styles/app.css';

const tracePropagationTargets = buildSentryTracePropagationTargets(
  import.meta.env.VITE_GATEWAY_API_URL,
);

initPortalSentry(tracePropagationTargets);

const bootstrap = async () => {
  await ensureDeviceFingerprint();
  setPortalSentryTag('device_id', getDeviceFingerprint());
  hydratePortalSentryUserFromStorage();
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
};

void bootstrap();

window.setTimeout(() => {
  void import('./app/registerFirebaseServiceWorker').then(
    ({ registerWarehouseFirebaseServiceWorker }) => registerWarehouseFirebaseServiceWorker(),
  );
}, 0);
